import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Auth.css';
import { MicrosoftIcon } from '../components/Icons';

export default function AuthPage() {
  const { loginWithMicrosoft, loading } = useAuth();

  return (
    <div className="auth-container">
      <div className="auth-background">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
        <div className="dot-grid"></div>
      </div>

      <div className="auth-content">
        <div className="auth-card-premium fade-in">
          <div className="auth-card-inner">
            <header className="auth-brand-header">
              <img src={`${process.env.PUBLIC_URL}/logo.jpg`} alt="University Logo" className="auth-university-logo" />
            </header>

            <div className="auth-welcome-text">
              <h1>Welcome to Guest Portal</h1>
              <p>The centralized guest management system for<br /><strong>K.R. Mangalam University</strong></p>
            </div>

            <div className="auth-actions-centered">
              <button
                type="button"
                className="btn-microsoft-premium"
                onClick={loginWithMicrosoft}
                disabled={loading}
              >
                {loading ? (
                  <div className="loading-row">
                    <div className="spinner-sm" />
                    <span>Redirecting...</span>
                  </div>
                ) : (
                  <>
                    <MicrosoftIcon />
                    <span>Sign in with Microsoft</span>
                  </>
                )}
              </button>
            </div>

            <footer className="auth-footer-note">
              By signing in, you agree to the university's Terms of Service regarding data usage and application access.
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
}
